<template>
  <div class="product col col-xs-12 col-sm-4 col-md-3 pb-3">
    <div class="card">
      <!-- <div class="card-header"> 
                <button type="button" class="close" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div> -->
      <div class="card-body">
        <div
          class="text-center preview-img"
          :style="{ backgroundImage: 'url(\'' + productImages[0] + '\')' }"
        >
          <div class="row">
            <div class="col-xs-6 text-left">
              <div class="share-product" @click="showLink = true">
                <span class="glyphicon glyphicon-share-alt"></span>
              </div>
              <modal-share-link
                v-if="showLink"
                @close="showLink = false"
                :productid="product.id"
                :pageid="
                  selectedBot.facebook_page_id ? selectedBot.facebook_page_id : selectedBot.pageid
                "
              ></modal-share-link>
            </div>

            <div class="col-xs-6 text-right">
              <div
                class="text-center sale-tag"
                v-if="
                  product.discountprice &&
                    parseFloat(product.price) > parseFloat(product.discountprice)
                "
              >
                Sale <br />
                {{
                  (((product.price - product.discountprice) / product.price) * 100) | numberFormat
                }}%
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12">
            <div style="padding:15px;border-bottom: 1px solid #eee">
              <div class="name" :title="product.name">{{ product.name | truncate(20) }}</div>
              <!-- <div class="price"><template v-if="product.discountprice &&  parseFloat(product.price) > parseFloat(product.discountprice)">{{ product.discountprice | currency(currencySign) }}</template><template v-else>{{ product.price | currency(currencySign) }}</template></div>
                            <div class="discount" v-if="product.discountprice &&  parseFloat(product.price) > parseFloat(product.discountprice)">{{ product.price | currency(currencySign) }}</div><div v-else class="discount"></div> -->
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <div class="row">
          <div class="card-btn col-xs-12 text-center">
            <a
              href="javascript:void(0);"
              data-toggle="modal"
              data-target="#modal_edit_product"
              @click="showModal = true"
              >Edit</a
            >
          </div>
        </div>
      </div>
    </div>

    <modal-edit-product
      v-if="showModal"
      v-model="product"
      @close="close()"
      @productDeleted="$emit('productDeleted')"
      :selectCategory="selectCategory"
      :category="category"
    ></modal-edit-product>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import StockItem from './StockItem.vue'
import ModalEditProduct from './ModalEditProduct'
import ModalShareLink from './ModalShareLink'
export default {
  props: ['value', 'category', 'selectCategory'],
  data: function() {
    return {
      product: this.value,

      showModal: false,
      showLink: false
    }
  },
  components: {
    ModalEditProduct,
    StockItem,
    ModalShareLink
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    productImages: function() {
      return this.product.photourl.split(';;')
    },
    currencySign: function() {
      if (this.product && this.product.currency) {
        switch (this.product.currency.toUpperCase()) {
          case 'THB':
            return '฿'
          case 'MMK':
            return 'K'
          case 'GBP':
            return '£'
          default:
            return '$'
        }
      }
      return '$'
    }
  },
  methods: {
    close: function() {
      let vm = this
      vm.showModal = false
      $('body').removeClass('modal-open')
      vm.$nextTick(function() {
        vm.$emit('input', vm.product)
      })
    }
  },
  watch: {
    value: function(newVal, oldVal) {
      if (newVal != oldVal) {
        this.product = this.value
      }
    },
    showModal: function(newVal, oldVal) {
      if (newVal) {
        $('body').addClass('modal-open')
      } else {
        $('body').removeClass('modal-open')
      }
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/event/Product.vue